export class ApplicantDto {
  constructor(obj = {}) {
    this.name = obj.name ? obj.name : "";
    this.teamName = obj.teamName ? obj.teamName : "";
    this.teamNames = obj.teamNames;
  }
}
